import React, { useState } from "react";

const WEB3FORMS_ACCESS_KEY = "5dd7e12e-b551-4164-9ebf-460596c3f568";

function InformationForm({ className = "", submitLabel = "Send message" }) {
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.set("access_key", WEB3FORMS_ACCESS_KEY);
    formData.set("subject", `PyLoan information request: ${formData.get("subject")}`);
    formData.set("from_name", formData.get("name"));

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        form.reset();
        setStatus({
          type: "success",
          message: "Thanks. Your information request has been sent.",
        });
      } else {
        setStatus({
          type: "error",
          message: "We could not send your request. Please try again or email us directly.",
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message: "We could not send your request. Please try again or email us directly.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className={`information_form ${className}`} onSubmit={onSubmit}>
      <label htmlFor="information-name">
        Your name <span className="required">*</span>
      </label>
      <input id="information-name" name="name" type="text" autoComplete="name" required />

      <label htmlFor="information-email">
        Email address <span className="required">*</span>
      </label>
      <input id="information-email" name="email" type="email" autoComplete="email" required />

      <label htmlFor="information-phone">
        Phone number <span className="required">*</span>
      </label>
      <input id="information-phone" name="phone" type="tel" autoComplete="tel" inputMode="tel" required />

      <label htmlFor="information-subject">
        What would you like to know? <span className="required">*</span>
      </label>
      <select id="information-subject" name="subject" defaultValue="" required>
        <option value="" disabled>Select a topic</option>
        <option value="loan-guides">Loan guides</option>
        <option value="government-schemes">Government schemes</option>
        <option value="women-entrepreneur-finance">Women entrepreneur finance</option>
        <option value="website-question">Website or privacy question</option>
      </select>

      <label htmlFor="information-message">
        Your question <span className="required">*</span>
      </label>
      <textarea id="information-message" name="message" rows="4" required></textarea>

      <input type="checkbox" name="botcheck" className="hidden" tabIndex="-1" autoComplete="off" />
      <button className="btn contact_btn" type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Sending..." : submitLabel}
      </button>
      <p className="contact_form_notice">
        PyLoan uses these details only to reply to your general information
        question. Do not send passwords, OTPs or bank login details.
      </p>
      {status.message && (
        <p className={`val_msg ${status.type}`} role="status">{status.message}</p>
      )}
    </form>
  );
}

export default InformationForm;
